import { memo, useCallback } from 'react';

import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { Ai } from '@air/next-icons';
import { Badge } from '@air/primitive-badge';
import { useAirModal } from '@air/provider-modal';

import { UpsellModal } from '~/components/v2/components/upsells/UpsellModal';

export const SidebarNavigationUpsell = memo(() => {
  const [showUpsellModal] = useAirModal(UpsellModal);

  const onClick = useCallback(() => {
    showUpsellModal();
  }, [showUpsellModal]);

  return (
    <SidebarNavigationItem data-id="unlock-features" onClick={onClick} prefix={<Ai className="size-4" />}>
      <div className="flex w-full items-center gap-2 overflow-hidden">
        <span className="truncate">Unlock new features</span>
        <Badge appearance="pill" color="blue" size="small" className="shrink-0">
          NEW
        </Badge>
      </div>
    </SidebarNavigationItem>
  );
});

SidebarNavigationUpsell.displayName = 'SidebarNavigationUpsell';
